import React, { useEffect, useState } from "react";
import Loading from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import {
  faDeleteLeft,
  faPrint,
  faEye,
  faEyeLowVision,
  faSheetPlastic,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FileSaver from "file-saver";
import { useReactToPrint } from "react-to-print";
import { PDFDocument } from "pdf-lib";
import CheckPackage from "./checkPackage.js";
import TaskPopUp from "./task_popup.js";
import AddPostFile from "./addPostFile.js";
import ShowPostDetail from "./showPostDetail.js";

const PostBookSend2 = (props) => {
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState(false);
  const [buffer, setBuffer] = useState([]);
  const [bufferClear, setBufferClear] = useState([]);
  const [taskNumberPost, setTaskNumberPost] = useState([]);
  const [descPost, setDescPost] = useState([]);
  const [dateFilterFrom, setDateFilterFrom] = useState("");
  const [dateFilterTo, setDateFilterTo] = useState("");
  const [contentFilter, setContentFilter] = useState("");
  const [packageInfo, setPackageInfo] = useState(false);
  const [packageInfoNum, setPackageInfoNum] = useState("");
  const [showTask, setShowTask] = useState(false);
  const [showTaskId, setShowTaskId] = useState("");
  const [postBookDate, setPostBookDate] = useState([]);
  const [expand, setExpand] = useState("");
  const [expandYear, setExpandYear] = useState(new Date().getFullYear());
  const [expandMonth, setExpandMonth] = useState("");
  const [postFile, setPostFile] = useState("");
  const [showFile, setShowFile] = useState(false);
  const [showFileID, setShowFileID] = useState("");
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [details, setDetails] = useState("");
  const [numNad, setNumNad] = useState("");

  const showAddFile = (e) => {
    setShowFileID(e.target.value);
    setShowFile(true);
  };

  const showDetailsF = (e) => {
    setDetails(e.currentTarget.value);
    setNumNad(e.currentTarget.attributes.value2.value);
    setShowDetails(true);
  };

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  function compareNumbers(a, b) {
    return b - a;
  }

  const fetchArr = async () => {
    await fetch("https://apidevkppp.ftpeople.pl/getPostListSendDetails", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        try {
          var test = data;
          var years = [];
          var months = [];
          data.map((el) => {
            var month = new Date(el.date).getMonth() + 1;
            var year = new Date(el.date).getFullYear();

            if (years.filter((y) => +y === +year).length === 0) {
              years.push(year);
            }

            if (months.filter((m) => +m === +month).length === 0) {
              months.push(month);
            }
          });
        } catch (err) {}

        setBuffer(test);
        setBufferClear(test);
        setYears(years.sort(compareNumbers));
        setMonths(months.sort(compareNumbers));

        fetchArr2();
      })
      .catch((error) => {});
  };

  const fetchArr2 = async () => {
    await fetch("https://apidevkppp.ftpeople.pl/getPostListSend", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setPostBookDate(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getFilteredBuffer = () => {
    setFilter(true);
    var arr = bufferClear;
    if (dateFilterFrom.length > 0 && dateFilterTo.length > 0) {
      arr = arr.filter(
        (el) =>
          new Date(el.date) >= new Date(dateFilterFrom) &&
          new Date(el.date) <= new Date(dateFilterTo)
      );
    }

    if (contentFilter.length > 0) {
      arr = arr.filter(
        (el) =>
          el.numNad.includes(contentFilter) ||
          (el.name ? el.name : "")
            .toString()
            .toLowerCase()
            .includes(contentFilter.toString().toLowerCase()) ||
          el.task.includes(contentFilter) ||
          el.addressFull.includes(contentFilter) ||
          (el.desc ? el.desc : "")
            .toString()
            .toLowerCase()
            .includes(contentFilter.toString().toLowerCase())
      );
    }

    setBuffer(arr);
  };

  const getData = () => {
    setLoading(true);
    fetchArr();
  };

  useEffect(() => {
    getData();
  }, []);

  const fetchPrintLabel = async (e) => {
    var body = {
      guid: e.currentTarget.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getPostBookByGuid", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        handleOpenPdfInNewTab(data.printResult[0].print);
      })
      .catch((error) => {});
  };

  const fetchPrintLabelMobile = async (e) => {
    var body = {
      guid: e.currentTarget.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getPostBookByGuid", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        handleDownloadPdfInNewTab(data.printResult[0].print);
      })
      .catch((error) => {});
  };

  const handleDownloadPdfInNewTab = (base64Pdf) => {
    var string = doc.output(`data:application/pdf;base64,${base64Pdf}`);
    var iframe =
      "<iframe width='100%' height='100%' src='" + string + "'></iframe>";
    var x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();
    return;
    var pdf = `data:application/pdf;base64,${base64Pdf}`;

    const pdfLink = pdf;
    const anchorElement = document.createElement("a");
    const fileName = `raport.pdf`;
    anchorElement.href = pdfLink;
    anchorElement.download = fileName;
    anchorElement.click();
  };

  const handleOpenPdfInNewTab = (base64Pdf) => {
    try {
      var pdfData = `data:application/pdf;base64,${base64Pdf}`;

      var w = window.open("");

      if (w) {
        w.document.write(
          `<embed width="100%" height="100%" src="${pdfData}" type="application/pdf" />`
        );
      } else {
        throw new Error("Failed to open a new tab.");
      }
    } catch (error) {
      console.error("Error opening PDF in new tab:", error);
      // } finally {
      //   if (w) w.document.close();
      // }
    }
  };

  const showCheck = (e) => {
    setPackageInfoNum(e.currentTarget.value);
    setPackageInfo(true);
  };

  const showTaskPopUp = (e) => {
    setShowTask(true);
    setShowTaskId(e.currentTarget.value);
  };

  const print = async (e) => {
    var body = { guid: e.target.value };

    await fetch("https://apidevkppp.ftpeople.pl/getLabelForPostbook", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        handleOpenPdfInNewTab(data.pdfContent);
      });
  };

  const download = async (url, filename) => {
    const data = await fetch(url);
    const blob = await data.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.setAttribute("href", objectUrl);
    link.setAttribute("target", "_blank");
    link.setAttribute("download", filename);
    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const downloadFile2 = (e) => {
    var url = e.currentTarget.value;
    download(url, "dokument pocztowy.pdf");
  };

  const getMonthName = (month) => {
    switch (month) {
      case 1:
        return "Styczeń";
      case 2:
        return "Luty";
      case 3:
        return "Marzec";
      case 4:
        return "Kwiecień";
      case 5:
        return "Maj";
      case 6:
        return "Czerwiec";
      case 7:
        return "Lipiec";
      case 8:
        return "Sierpień";
      case 9:
        return "Wrzesień";
      case 10:
        return "Październik";
      case 11:
        return "Listopad";
      case 12:
        return "Grudzień";
      default:
        return "Styczeń";
    }
  };

  const bufferData = (
    <>
      <p id="asd4" style={{ textAlign: "right" }}>
        Liczba wysyłek: {buffer ? buffer.length : 0}
      </p>
      {years.map((year) => (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <p style={{ fontWeight: "900" }}>{year}</p>{" "}
            {expandYear !== year ? (
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={() => setExpandYear(year)}
              >
                Rozwiń
              </button>
            ) : (
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={() => setExpandYear("")}
              >
                Zwiń
              </button>
            )}
          </div>
          {filter || expandYear === year ? (
            <>
              {months
                .filter(
                  (ep) =>
                    postBookDate.filter(
                      (ele) =>
                        +new Date(ele.date).getFullYear() === +year &&
                        +new Date(ele.date).getMonth() + 1 === +ep
                    ).length > 0
                )
                .map((month) => (
                  <>
                    <br />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <p style={{ fontWeight: "600", width: "100px" }}>
                        {getMonthName(+month).toLocaleUpperCase()}
                      </p>{" "}
                      {expandMonth !== month ? (
                        <button
                          style={{
                            backgroundColor: "#00bdce",
                            border: "none",
                            color: "white",
                            fontWeight: "600",
                            borderRadius: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          id="clientsFilterButton"
                          className="paymentMenuButton"
                          onClick={() => setExpandMonth(month)}
                        >
                          Rozwiń
                        </button>
                      ) : (
                        <button
                          style={{
                            backgroundColor: "#00bdce",
                            border: "none",
                            color: "white",
                            fontWeight: "600",
                            borderRadius: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          id="clientsFilterButton"
                          className="paymentMenuButton"
                          onClick={() => setExpandMonth("")}
                        >
                          Zwiń
                        </button>
                      )}
                    </div>
                    {filter || expandMonth === month ? (
                      <>
                        {" "}
                        {postBookDate
                          .filter(
                            (ele) =>
                              +new Date(ele.date).getFullYear() === +year &&
                              +new Date(ele.date).getMonth() + 1 === +month
                          )
                          .map((ex) => (
                            <>
                              {buffer.filter(
                                (eq) => eq.idEnvelope === ex.idEnvelope
                              ).length > 0 ? (
                                <>
                                  <div
                                    style={{
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                    id="asd7"
                                  >
                                    <p style={{ width: "200px" }}>
                                      {ex.idEnvelope} - {ex.date}
                                    </p>
                                    {expand !== ex.idEnvelope ? (
                                      <button
                                        style={{
                                          backgroundColor: "#00bdce",
                                          border: "none",
                                          color: "white",
                                          fontWeight: "600",
                                          borderRadius: "15px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        id="asd8"
                                        className="paymentMenuButton"
                                        onClick={() => setExpand(ex.idEnvelope)}
                                      >
                                        Rozwiń
                                      </button>
                                    ) : (
                                      <button
                                        style={{
                                          backgroundColor: "#00bdce",
                                          border: "none",
                                          color: "white",
                                          fontWeight: "600",
                                          borderRadius: "15px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        id="asd8"
                                        className="paymentMenuButton"
                                        onClick={() => setExpand("")}
                                      >
                                        Zwiń
                                      </button>
                                    )}
                                    <button
                                      style={{
                                        backgroundColor: "#00bdce",
                                        border: "none",
                                        color: "white",
                                        fontWeight: "600",
                                        borderRadius: "15px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                      id="asd8"
                                      className="paymentMenuButton"
                                      value={ex.linkBase}
                                      onClick={downloadFile2}
                                    >
                                      Drukuj książkę
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor: "#00bdce",
                                        border: "none",
                                        color: "white",
                                        fontWeight: "600",
                                        borderRadius: "15px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                      id="asd8"
                                      className="paymentMenuButton"
                                      value={ex.idEnvelope}
                                      onClick={showAddFile}
                                    >
                                      ZAŁADUJ PLIK Z PODPISEM
                                    </button>
                                    {ex.link.length > 0 ? (
                                      <button
                                        style={{
                                          backgroundColor: "#00bdce",
                                          border: "none",
                                          color: "white",
                                          fontWeight: "600",
                                          borderRadius: "15px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        id="asd8"
                                        className="paymentMenuButton"
                                        value={ex.link}
                                        onClick={downloadFile2}
                                      >
                                        POBIERZ PLIK Z PODPISEM
                                      </button>
                                    ) : (
                                      ""
                                    )}
                                    <p>
                                      Ilość rekordów:{" "}
                                      {
                                        buffer.filter(
                                          (eq) =>
                                            eq.idEnvelope === ex.idEnvelope
                                        ).length
                                      }
                                    </p>
                                  </div>

                                  <div
                                    style={
                                      filter || expand === ex.idEnvelope
                                        ? { display: "block" }
                                        : { display: "none" }
                                    }
                                  >
                                    <div id="asd2">
                                      <table className="clients_table">
                                        <tr key={0}>
                                          <th>Lp.</th>
                                          <th>Data wysyłki</th>
                                          <th>Numer nadania</th>
                                          <th>Nazwa</th>
                                          <th>Adres</th>
                                          <th>Kategoria</th>
                                          <th>Potwierdzenie odbioru</th>
                                          <th>Zadanie</th>
                                          <th>Opis</th>
                                          <th>Akcja</th>
                                        </tr>
                                        {buffer.filter(
                                          (eq) =>
                                            eq.idEnvelope === ex.idEnvelope
                                        ).length === 0 ? (
                                          <></>
                                        ) : (
                                          buffer
                                            .filter(
                                              (eq) =>
                                                eq.idEnvelope === ex.idEnvelope
                                            )
                                            .map((el, index) => (
                                              <>
                                                <tr id={""} key={el.id}>
                                                  <td>{index + 1}</td>
                                                  <td>{el.date}</td>
                                                  <td>{el.numNad}</td>
                                                  <td>{el.name}</td>
                                                  <td>{`${el.street} ${el.number}, ${el.postCode} ${el.city}`}</td>
                                                  <td>{el.category}</td>
                                                  <td>{el.potOdb}</td>
                                                  <td>
                                                    {el.task !==
                                                    "nie powiązano" ? (
                                                      <>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            justifyContent:
                                                              "center",
                                                            gap: "10px",
                                                          }}
                                                        >
                                                          {el.task}
                                                          <button
                                                            style={{
                                                              width: "10%",
                                                              backgroundColor:
                                                                "transparent",
                                                              color: "#a5bea4",
                                                              border: "none",
                                                              fontSize: "1vw",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                            id="clientsButton"
                                                            className="paymentMenuButton"
                                                            value={el.task}
                                                            onClick={
                                                              showTaskPopUp
                                                            }
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={faEye}
                                                            />
                                                          </button>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      el.task
                                                    )}
                                                  </td>
                                                  <td>{el.descX}</td>
                                                  <td>
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        gap: "10px",
                                                      }}
                                                    >
                                                      {el.linkX ? (
                                                        <button
                                                          style={{
                                                            width: "10%",
                                                            backgroundColor:
                                                              "transparent",
                                                            color: "#a5bea4",
                                                            border: "none",
                                                            fontSize: "1vw",
                                                            textAlign: "center",
                                                          }}
                                                          id="clientsButton"
                                                          className="paymentMenuButton"
                                                          value={el.linkX}
                                                          onClick={
                                                            downloadFile2
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPrint}
                                                          />
                                                        </button>
                                                      ) : (
                                                        <button
                                                          style={{
                                                            width: "10%",
                                                            backgroundColor:
                                                              "transparent",
                                                            color: "#a5bea4",
                                                            border: "none",
                                                            fontSize: "1vw",
                                                            textAlign: "center",
                                                          }}
                                                          id="clientsButton"
                                                          className="paymentMenuButton"
                                                          value={el.guid}
                                                          onClick={
                                                            fetchPrintLabel
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPrint}
                                                          />
                                                        </button>
                                                      )}
                                                      <button
                                                        style={{
                                                          width: "10%",
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#a5bea4",
                                                          border: "none",
                                                          fontSize: "1vw",
                                                          textAlign: "center",
                                                        }}
                                                        id="clientsButton"
                                                        className="paymentMenuButton"
                                                        value={el.numNad}
                                                        onClick={showCheck}
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faEye}
                                                        />
                                                      </button>
                                                    </div>
                                                  </td>
                                                </tr>
                                              </>
                                            ))
                                        )}
                                      </table>
                                    </div>
                                    <div id="asd3">
                                      <table className="clients_table">
                                        <tr key={0}>
                                          <th>Nazwa</th>
                                          <th>Kategoria</th>
                                          <th>Akcja</th>
                                        </tr>
                                        {buffer.filter(
                                          (eq) =>
                                            eq.idEnvelope === ex.idEnvelope
                                        ).length === 0 ? (
                                          <></>
                                        ) : (
                                          buffer
                                            .filter(
                                              (eq) =>
                                                eq.idEnvelope === ex.idEnvelope
                                            )
                                            .map((el, index) => (
                                              <>
                                                <tr id={""} key={el.id}>
                                                  <td>{el.name}</td>
                                                  <td>{el.category}</td>

                                                  <td>
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        gap: "10px",
                                                      }}
                                                    >
                                                      <div id="asd2">
                                                        <button
                                                          style={{
                                                            width: "10%",
                                                            backgroundColor:
                                                              "transparent",
                                                            color: "#a5bea4",
                                                            border: "none",

                                                            textAlign: "center",
                                                          }}
                                                          id="asd5"
                                                          className="paymentMenuButton"
                                                          value={el.guid}
                                                          onClick={
                                                            fetchPrintLabel
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPrint}
                                                          />
                                                        </button>
                                                      </div>
                                                      <div id="asd3">
                                                        <button
                                                          style={{
                                                            width: "10%",
                                                            backgroundColor:
                                                              "transparent",
                                                            color: "#a5bea4",
                                                            border: "none",

                                                            textAlign: "center",
                                                          }}
                                                          id="asd5"
                                                          className="paymentMenuButton"
                                                          value={el.guid}
                                                          onClick={
                                                            fetchPrintLabelMobile
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPrint}
                                                          />
                                                        </button>
                                                      </div>
                                                      <button
                                                        style={{
                                                          width: "10%",
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#a5bea4",
                                                          border: "none",

                                                          textAlign: "center",
                                                        }}
                                                        id="asd5"
                                                        className="paymentMenuButton"
                                                        value={el.numNad}
                                                        onClick={showCheck}
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faEye}
                                                        />
                                                      </button>
                                                      <button
                                                        style={{
                                                          width: "10%",
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#a5bea4",
                                                          border: "none",

                                                          textAlign: "center",
                                                        }}
                                                        id="asd5"
                                                        className="paymentMenuButton"
                                                        value={el.idEnvelope}
                                                        value2={el.numNad}
                                                        onClick={showDetailsF}
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faSheetPlastic}
                                                        />
                                                      </button>
                                                    </div>
                                                  </td>
                                                </tr>
                                              </>
                                            ))
                                        )}
                                      </table>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          ))}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ))}
            </>
          ) : (
            ""
          )}
        </>
      ))}
    </>
  );

  const clearFilters = () => {
    setFilter(false);
    setDateFilterFrom("");
    setDateFilterTo("");
    setContentFilter("");
    setBuffer(bufferClear);
  };

  return (
    <>
      <div className="mainContainerPayments">
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        {loading ? (
          <>
            <Loading />
          </>
        ) : (
          <>
            {showFile ? (
              <AddPostFile
                close={() => {
                  setShowFile(false);
                  setShowFileID("");
                  getData();
                }}
                idEnvelope={showFileID}
              />
            ) : (
              ""
            )}
            {packageInfo ? (
              <>
                <CheckPackage
                  close={() => setPackageInfo(false)}
                  num={packageInfoNum}
                />
              </>
            ) : (
              ""
            )}
            {showDetails ? (
              <>
                <ShowPostDetail
                  close={() => {
                    setShowDetails(false);
                  }}
                  numNad2={numNad}
                  numNad={details}
                  task={
                    taskNumberPost.filter((el) => el.guid === details).length >
                    0
                      ? {
                          id: taskNumberPost.filter(
                            (el) => el.guid === details
                          )[0].taskId,
                        }
                      : ""
                  }
                  desc={
                    descPost.filter((el) => el.guid === details).length > 0
                      ? descPost.filter((el) => el.guid === details)[0].desc
                      : ""
                  }
                  mode={"send"}
                />
              </>
            ) : (
              ""
            )}
            {showTask ? (
              <>
                <TaskPopUp
                  taskID={showTaskId}
                  hearingsData={props.hearingsData}
                  tasksData={props.tasksData}
                  tasksSheetData={props.tasksSheetData}
                  closeTaskPopUp={() => setShowTask(false)}
                  lawyersData={props.lawyersData}
                  refreshData={props.refreshData}
                  user={props.uData}
                  courtsData={props.courtsData}
                  banksData={props.banksData}
                  usersData={props.users}
                  resultsData={props.resultsData}
                  tasksTypesData={props.tasksTypesData}
                  history={false}
                  checkPermissions={props.checkPermissions}
                  team={props.team}
                  hearingsTeam2Data={props.hearingsTeam2Data}
                  hearingsTeam2SheetData={props.hearingsTeam2SheetData}
                  tasksTeam2Data={props.tasksTeam2Data}
                  tasksTeam2SheetData={props.tasksTeam2SheetData}
                  archTasksTeam2={props.tasksArchTeam2SheetData}
                  archTasks={props.archTasks}
                  logClientAction={props.logClientAction}
                  close={() => setShowTask(false)}
                  tabIndex={0}
                  clientsData={props.clientsFullData}
                  filesData={props.filesData}
                  user={props.user}
                />
              </>
            ) : (
              <>
                <div
                  id="asd1"
                  style={{
                    marginTop: "0",
                    marginBottom: "5vh",
                  }}
                >
                  <label style={{ fontSize: "1vw", fontWeight: "600" }}>
                    Zakres dat
                  </label>
                  <div
                    style={{ marginTop: "5px" }}
                    id="asd6"
                    className="inputBox"
                  >
                    <div id="asd" className="inputCol_2">
                      <label style={{ fontSize: "1vw" }}>Od</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={dateFilterFrom}
                        onChange={(e) => setDateFilterFrom(e.target.value)}
                      />
                    </div>
                    <div id="asd" className="inputCol_2">
                      <label style={{ fontSize: "1vw" }}>Do</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={dateFilterTo}
                        onChange={(e) => {
                          setDateFilterTo(e.target.value);
                        }}
                      />
                    </div>
                    <div id="asd" className="inputCol_2">
                      <label style={{ fontSize: "1vw" }}>
                        Numer przesyłki, adres, nazwa, opis, zadanie
                      </label>
                      <input
                        style={{ height: "3vh" }}
                        type="text"
                        id="name"
                        name="name"
                        value={contentFilter}
                        onChange={(e) => {
                          setContentFilter(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{ marginTop: "2vh", display: "flex", gap: "10px" }}
                  >
                    <button
                      style={{
                        backgroundColor: "#00bdce",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      id="clientsFilterButton"
                      className="paymentMenuButton"
                      onClick={getFilteredBuffer}
                    >
                      Pokaż
                    </button>
                    <button
                      style={{
                        backgroundColor: "#00bdce",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      id="clientsFilterButton"
                      className="paymentMenuButton"
                      onClick={clearFilters}
                    >
                      WYCZyŚĆ
                    </button>
                  </div>
                </div>
                {buffer.length === 0 ? (
                  <>BRAK WYSŁANYCH PRZESYŁEK</>
                ) : (
                  <>{bufferData}</>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default PostBookSend2;
